import { RouteObject } from 'react-router';

import { ExportsCreateContainer } from '../exports/containers/ExportsCreateContainer';
import { OrderModal } from './containers/OrderModal';
import { OrdersContainer } from './containers/OrdersContainer';

const routes: RouteObject[] = [
    {
        path: 'orders',
        element: <OrdersContainer />,
        children: [
            {
                path: ':orderId',
                element: <OrderModal />,
            },
            {
                path: 'create',
                element: <ExportsCreateContainer />,
            },
        ],
    },
];

export default routes;
